import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { Button, CircularProgress, DialogActions, Zoom } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import StationsContainer from '../../containers/Stations';
import PricingRequestContainer from '../../containers/retailPricing/PricingRequest';
import FormComponent from '../FormComponent';
import FMPText from '../pureForm/FMPText';
import Transition from './Transition';
import FMPStationMultiSelect from '../pureForm/FMPStationMultiSelect';
import GreenChecked from '../../images/icons/greenChecked.svg';

const isLocalhost = Boolean(window.location.hostname === 'localhost');
const baseUrl = !isLocalhost ? 'https://fmp.pearsonfuels.com' : 'http://localhost:3001';
const smsUrl = `${baseUrl}/sms/XXXXX`;
const customMessage =
	`Hi, this is Pearson Fuels, your E85 supplier. ` +
	`Can you click the link below and let us know your E85 prices for your station?\n` +
	`${smsUrl}`;

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	greenCheckedIcon: {
		display: 'inline-block',
		width: 33,
		height: 33,
		backgroundImage: `url('${GreenChecked}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
		marginLeft: 5,
	},
	isSaving: {
		marginLeft: 20,
		fontSize: 16,
		color: '#1565C0',
	},
	savingSuccessful: {
		marginLeft: 20,
		fontSize: 16,
		color: '#2E7D32',
	},
});

class TestMultiSmsDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isSaving: false,
			isSent: false,
			pricingRequestMaxPrice: '',
			pricingRequestMinPrice: '',
		};
	}
	componentDidMount() {
		const { stations, searchStations } = this.props;
		if (_.isEmpty(stations)) {
			searchStations();
		}
	}

	handleClose = () => {
		this.setState(
			{
				isSaving: false,
			},
			this.props.onClose
		);
	};

	handleSendPricingRequest = () => {
		const { showErrors, addPricingRequest } = this.props;
		//- Required fields
		const formFieldError = {};
		const errors = [];

		const _setError = (path, error) => {
			_.set(formFieldError, path, error);
			errors.push(error);
		};

		let fields = [{ path: 'testMobileNumber', display: 'Test Number' }];
		fields.forEach((s) => {
			if (!_.get(this.state, s.path)) {
				_setError(s.path, `${s.display} is required`);
			}
		});

		const { multiStationIds, testMobileNumber } = this.state;

		if (_.isEmpty(multiStationIds)) {
			_setError('multiStationIds', `At least ONE station ID is required. Come on..`);
		}

		if (!testMobileNumber.match(/^[0-9]{10}$/)) {
			_setError('testMobileNumber', 'Mobile number number should only contain 10 digits.');
		}

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return showErrors(errors);
		}

		const params = {
			multiStationIds,
			testMobileNumber,
		};

		this.setState({
			isSaving: true,
		});

		addPricingRequest({
			params,
			callback: (err) => {
				this.setState({
					isSaving: false,
				});
				if (err) {
					showErrors([err]);
					return;
				}
				this.setState({
					isSent: true,
				});
			},
		});
	};

	render() {
		const { classes, open, fullScreen } = this.props;
		const { isSaving, isSent } = this.state;

		return (
			<Dialog
				maxWidth="md"
				fullScreen={fullScreen}
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
				fullWidth={true}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>Send a Test Multi-Site SMS Message</DialogTitle>
					<DialogContent>
						<FMPText
							helpText="Just 10 digits please"
							{...this.setForm(`testMobileNumber`, 'Phone Number', true)}
						/>

						<FMPStationMultiSelect
							{...this.setForm('multiStationIds', 'Stations', false, [])}
							stations={this.props.stations}
						/>

						<div style={{ marginBottom: 20, maxWidth: '550px' }}>
							<div
								style={{
									marginTop: 20,
									fontSize: 14,
									color: '#666',
									padding: '10px 0px',
								}}
							>
								Example message:
							</div>
							<div
								style={{
									lineHeight: 1.4,
									backgroundColor: '#438AF6',
									borderRadius: 10,
									padding: 14,
									color: 'white',
									whiteSpace: 'pre-line',
								}}
							>
								{customMessage}
							</div>
						</div>

						<Zoom
							in={isSaving}
							style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>

						<Zoom in={isSent} style={{ transitionDelay: isSent ? '250ms' : '0ms' }}>
							<div className={classes.savingSuccessful}>
								<div className={classes.greenCheckedIcon} />
								<span style={{ paddingLeft: 10 }}>Multi-site SMS sent successfully</span>
							</div>
						</Zoom>
					</DialogContent>

					<DialogActions>
						<Button onClick={this.handleClose}>Close</Button>
						<Button
							disabled={isSaving || isSent}
							variant="contained"
							onClick={this.handleSendPricingRequest}
							className={classes.submitButton}
							color="primary"
						>
							Send SMS
						</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

TestMultiSmsDialog.propTypes = {
	fullScreen: PropTypes.bool.isRequired,
	classes: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,

	searchStations: PropTypes.func.isRequired,
	addPricingRequest: PropTypes.func.isRequired,
	stations: PropTypes.array,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
	StationsContainer,
	PricingRequestContainer,
])(TestMultiSmsDialog);
